import { TemplateRef } from '@angular/core';

export interface HaloModalOptions {
  title?: string;
  titleUppercase?: boolean;
  modalSize?: HaloModalSize;
  icon?: string;
  iconClass?: string;
  dismissible?: boolean;
  message?: string;
  isVideoTree?:boolean;
  // go with template.
  titleTemplate?: TemplateRef<any>;
  bodyTemplate?: TemplateRef<any>;
  footerTemplate?: TemplateRef<any>;

  // functions
  onDismiss?: Function;
}

export enum HaloModalSize {
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
  XLarge = 'xl'
}
